import rootReducer from 'publisher/reducers'
import { applyMiddleware, compose, createStore } from 'redux'
import { thunk } from 'redux-thunk'

const configureStore = preloadedState => {
  // eslint-disable-next-line no-underscore-dangle

  const composeEnhancers =
    (typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose
  return createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(applyMiddleware(thunk)),
  )
}

export default configureStore
